class h {
  constructor() {
    this.events = {};
  }
  on(s, t) {
    this.events[s] || (this.events[s] = []), this.events[s].push(t);
  }
  emit(s, ...t) {
    this.events[s] && this.events[s].forEach((i) => {
      i(...t);
    });
  }
  off(s, t) {
    this.events[s] && (this.events[s] = this.events[s].filter((i) => i !== t));
  }
}
const n = new h();
export {
  n as default
};
